export const ENDPOINT = (store_slug: string, address_id: string) => {
  return `api/app/merchants/${store_slug}/checkout/delivery-tax/${address_id}`;
};

export type Request = {
  store_slug?: string;
  address_id?: string;
};

export type Response = {
  delivery_tax: number;
};
